import React from 'react'
import { Navigate } from 'react-router-dom'

import routePath from 'router/routePath'
import { useModuleConfig } from 'hooks/useModuleConfig/useModuleConfig'

type GymReservationsGateProps = {
  redirectTo?: string
  children: React.ReactElement
}

export const GymReservationsGate: React.FC<GymReservationsGateProps> = ({
  children,
  redirectTo = routePath.notFound404,
}) => {
  const { gymReservations } = useModuleConfig()
  return gymReservations.enabled ? (
    children
  ) : (
    <Navigate to={redirectTo} replace />
  )
}
